import Form from "antd/es/form/Form";
import { get } from "http";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "src/Components/Button";
import FullScreenLoading from "src/Components/Loading/FullScreenLoading";
import DynamicMultiSelectDropdown from "src/Components/Dropdown/DynamicMultiSelectDropdown";
import StaticDropdown from "src/Components/Dropdown/StaticDropdown";
import { StaticMultiSelectDropdown } from "src/Components/Dropdown/StaticMultiSelectDropdown";
import Modal from "src/Components/Modal/Modal";
import TextInput from "src/Components/TextInput";
import {
  IPortfoPairPositionTableReport,
  IPortfoPairPositionUser,
} from "src/Interfaces/deltaHedgeAccounts";
import {
  DeltaHedgeOrderType,
  IDeltaHedgeOrderFormValues,
} from "src/Interfaces/deltaHedgeOrder";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { IPairPositionReport } from "src/Interfaces/optionDomain";
import {
  StepOptionOrderType,
  StepOrderSide,
} from "src/Interfaces/stepInterfaces";
import OrderPreviewTable, { isDeltaHedgePreviewRowSendable } from "src/Pages/DeltaHedgeOrder/OrderPreviewTable";
import SahraConnections from "src/Pages/Sahra/SahraConnections";
import { sendOrders } from "src/Requests/adjustment";
import {
  getDeltaHedgeAccountsDropdown,
  getDeltaHedgeAccountsForPortfoDropdown,
} from "src/Requests/deltaHedgeAccounts";
import {
  addDeltaHedgeOrder,
  getDeltaHedgeOrders,
} from "src/Requests/deltaHedgeOrder";
import { getStepInstruments } from "src/Requests/stepRequests";
import { packetErrorHandler } from "src/Utils/requestUtils";
// Common Components
import UsersMultiSelectDropdown from "src/Components/Dropdown/Users/UsersMultiSelectDropdown";

interface IProps {
  row: IPairPositionReport;

  onAction: () => void;
}
export interface IGetDeltaHedgeOrderDTO {
  accountIds: number[];
  processType: DeltaHedgeOrderType;
  orderSide1: StepOrderSide;
  orderSide2: StepOrderSide;

  instrumentId1: string;
  instrumentId2: string;

  instrumentName1: string;
  instrumentName2: string;

  optionOrderType1: StepOptionOrderType;
  optionOrderType2: StepOptionOrderType;

  dailyLockPercent: number;
  blockSize: number;
  marginPercent: number;

  portfoPercent: number;
  involvedFund: string;
}

enum ModalMode {
  Closed,
  SahraOrderTable,
  OrderPreview,
}

const SendDeltaOrderRequestConfig = ({ row, onAction }: IProps) => {
  const [formValues, setFormValues] = useState({
    accountIds: [] as number[],
    orderSide1: row.orderSideValue1,
    orderSide2: row.orderSideValue2,
    instrumentId1: row.instrumentId1,
    instrumentId2: row.instrumentId2,
    instrumentName1: row.instrumentName1,
    instrumentName2: row.instrumentName2,

    optionOrderType1: StepOptionOrderType.Open,
    optionOrderType2: StepOptionOrderType.Open,

    dailyLockPercent: parseFloat(
      (row.dailyLockProfitPercent * 100).toPrecision(3)
    ),
    portfoPercent: 10,
    blockSize: 100,
    marginPercent: 0,
    involvedFund: row.involvedFund
      ?.replace(",", "")
      ?.replace(",", "")
      ?.replace(",", ""),
  } as IGetDeltaHedgeOrderDTO);

  const [instrumentOptions, setInstrumentOptions] = useState(
    [] as DropdownItem[]
  );

  const [deltaHedgeAccounts, setDeltaHedgeAccounts] = useState(
    [] as DropdownItem[]
  );

  const [modalMode, setModalMode] = useState(ModalMode.Closed);

  const [deltaHedgeOrders, setDeltaHedgeOrders] = useState<
    IDeltaHedgeOrderFormValues[]
  >([]);

  const [loading, setLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const sendableOrders = deltaHedgeOrders.filter(isDeltaHedgePreviewRowSendable);

  const orderTypeDropdown = [
    { id: StepOptionOrderType.Offset, name: "آفست" } as DropdownItem,
    { id: StepOptionOrderType.Open, name: "اپن" } as DropdownItem,
  ];

  const orderSideDropdown = [
    { id: StepOrderSide.Buy, name: "خرید" } as DropdownItem,
    { id: StepOrderSide.Sell, name: "فروش" } as DropdownItem,
  ];
  useEffect(() => {
    getStepInstruments()
      .then((resp) => {
        setInstrumentOptions(resp);
      })
      .catch(packetErrorHandler);

    getDeltaHedgeAccountsForPortfoDropdown()
      .then((r) => {
        setDeltaHedgeAccounts(r);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const sendDeltaHedgeOrders = () => {
    if (loading || !sendableOrders.length) return;
    setLoading(true);
    const requests = sendableOrders.map((order) => addDeltaHedgeOrder(order));
    Promise.all(requests)
      .then(() => {
        toast.success("با موفقیت انجام شد");
        onAction();
        setModalMode(ModalMode.Closed);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const getOrders = () => {
    return deltaHedgeOrders;
  };

  const sahraUserTableModalUI = (
    <div className="flex flex-col justify-start items-center gap-3">
      <SahraConnections
        initialSearchParam={{
          userIds: sendableOrders.map((order) => order.accountId),
        }}
      />

      <div className="w-[100px] mr-auto">
        <Button text="ثبت" variant="contained" onClick={sendDeltaHedgeOrders} disabled={loading || !sendableOrders.length} />
      </div>
    </div>
  );

  const orderPreviewModalUI = (
    <div className="flex flex-col justify-start items-center gap-3">
      <OrderPreviewTable values={getOrders()} />

      <div className="w-[100px] mr-auto">
        <Button
          text="ثبت"
          variant="contained"
          onClick={() => setModalMode(ModalMode.SahraOrderTable)}
          disabled={loading || !sendableOrders.length}
        />
      </div>
    </div>
  );

  const getModalMode = () => {
    switch (modalMode) {
      case ModalMode.Closed:
        return <></>;

      case ModalMode.SahraOrderTable:
        return sahraUserTableModalUI;

      case ModalMode.OrderPreview:
        return orderPreviewModalUI;

      default:
        return <></>;
    }
  };

  function submitHandler(): void {
    if (previewLoading || loading) return;
    setPreviewLoading(true);
    getDeltaHedgeOrders(formValues)
      .then((r) => {
        setDeltaHedgeOrders(r.map((order) => ({ ...order, portfoPercent: order.portfoPercent ?? formValues.portfoPercent, involvedFund: order.involvedFund ?? formValues.involvedFund, instrumentName1: formValues.instrumentName1, instrumentName2: formValues.instrumentName2 })));
        setModalMode(ModalMode.OrderPreview);
      })
      .catch(packetErrorHandler)
      .finally(() => setPreviewLoading(false));
  }

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      {previewLoading ? <FullScreenLoading /> : null}
      {modalMode !== ModalMode.Closed ? (
        <Modal
          modalBoxClassName="!min-w-0 w-[1320px]"
          onClose={() => setModalMode(ModalMode.Closed)}
          UI={getModalMode()}
        />
      ) : (
        <></>
      )}

      <UsersMultiSelectDropdown
        label="اکانت ها"
        name="accountIds"
        value={Array.from(
          new Set(formValues.accountIds.map((x) => x.toString()))
        )}
        onChange={changeHandler}
        extraLabel
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: "نماد جهت اول",
          disabled: true,
          extraLabel: true,
        }}
        value={row.instrumentId1}
        options={instrumentOptions}
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: "نماد جهت دوم",
          disabled: true,
          extraLabel: true,
        }}
        value={row.instrumentId2}
        options={instrumentOptions}
      />

      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: " جهت اول",
          disabled: true,
          extraLabel: true,
        }}
        value={formValues.orderSide1}
        options={orderSideDropdown}
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: " جهت دوم",
          disabled: true,
          extraLabel: true,
        }}
        value={formValues.orderSide2}
        options={orderSideDropdown}
      />

      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: " نوع معامله اول",
          disabled: true,
          extraLabel: true,
        }}
        value={formValues.optionOrderType1}
        options={orderTypeDropdown}
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: " نوع معامله دوم",
          disabled: true,
          extraLabel: true,
        }}
        value={formValues.optionOrderType2}
        options={orderTypeDropdown}
      />

      <TextInput
        label="% بازده قفل پورتفو"
        value={formValues.dailyLockPercent?.toString()}
        name="dailyLockPercent"
        onChange={changeHandler}
        extraLabel
      />

      <TextInput
        label="% از پرتفو"
        value={formValues.portfoPercent?.toString()}
        name="portfoPercent"
        onChange={changeHandler}
        extraLabel
      />

      <TextInput
        label="% بلوک"
        value={formValues.blockSize?.toString()}
        name="blockSize"
        onChange={changeHandler}
        extraLabel
      />

      <TextInput
        label="% مارجین"
        value={formValues.marginPercent?.toString()}
        name="marginPercent"
        onChange={changeHandler}
        extraLabel
      />
      <hr />
      <Button text="ثبت" variant="contained" onClick={submitHandler} loading={previewLoading} disabled={previewLoading || loading} />
    </Form>
  );
};

export default SendDeltaOrderRequestConfig;
